export function extractHeaderLabels(table: HTMLTableElement): string[] {
  const headerRow = table.querySelector('thead tr');
  if (!headerRow) return [];
  const labels: string[] = [];
  let columnIndex = 0;
  Array.from(headerRow.children).forEach((child) => {
    if (!(child instanceof HTMLTableCellElement)) return;
    const span = child.colSpan || 1;
    const text = (child.textContent || '').replace(/\s+/g, ' ').trim();
    const label = text || child.getAttribute('data-label') || '';
    for (let i = 0; i < span; i += 1) {
      labels[columnIndex] = label;
      columnIndex += 1;
    }
  });
  return labels;
}

export function applyCellLabels(table: HTMLTableElement, labels: string[]) {
  const bodyRows = table.querySelectorAll('tbody tr');
  bodyRows.forEach((row) => {
    let index = 0;
    Array.from(row.children).forEach((cell) => {
      if (!(cell instanceof HTMLTableCellElement)) return;
      const span = cell.colSpan || 1;
      const existing = cell.getAttribute('data-label');
      const label = existing || (span > 1 ? '' : labels[index] || '');
      if (label) {
        cell.setAttribute('data-label', label);
      } else {
        cell.removeAttribute('data-label');
      }
      index += span;
    });
  });
}

